module.exports = __webpack_public_path__ + "static/tangled_3-pc-installation-20b75c704fa8306785580ded61fee28e.jpg";